// Dutch (nl)
export default {
  // --- Shell / nav ---
  app_name: 'Getijden in de buurt',
  search_stations: 'Stations zoeken',
  search_stations_hint: 'Stations zoeken (⌘K)',
  settings: 'Instellingen',
  app_store: 'Download in de App Store',
  google_play: 'Ontdek het op Google Play',
  app_promo_title: 'Download de gratis app. Die is sneller 🙂',
  app_promo_body: 'Dezelfde getijden- en stromingsvoorspellingen, op je telefoon.',
  privacy: 'Privacy',
  terms: 'Voorwaarden',
  data_sources: 'Gegevensbronnen',
  support: 'Ondersteuning',

  guides: 'Gidsen',
  // --- Home ---
  home_title: 'Vind getijden en stromingen in de buurt',
  by_country: 'Op land',
  favorite_tides: 'Favoriete getijden',
  recent_tides: 'Recente getijden',
  nearby_tides: 'Getijden in de buurt',
  favorite_currents: 'Favoriete stromingen',
  recent_currents: 'Recente stromingen',
  nearby_currents: 'Stromingen in de buurt',
  favorite_charts: 'Favoriete zeekaarten',
  recent_charts: 'Recente zeekaarten',
  nearby_charts: 'Zeekaarten in de buurt',
  finding_stations: 'Stations in de buurt zoeken…',
  distance_away: '{{distance}} verderop',

  // --- Search overlay ---
  search_placeholder: 'Zoek stations…',
  tide_stations: 'Getijdenstations',
  current_stations: 'Stromingstations',
  recents: 'Recent',
  search_unavailable: 'Zoeken is momenteel niet beschikbaar.',
  no_stations_found: 'Geen stations gevonden.',
  search_prompt: 'Zoek getijden- en stromingstations op naam.',

  // --- Settings ---
  appearance: 'Weergave',
  appearance_system: 'Systeem',
  appearance_light: 'Licht',
  appearance_dark: 'Donker',
  tide_height: 'Getijhoogte',
  unit_feet: 'Voet',
  unit_meters: 'Meter',
  distance: 'Afstand',
  unit_miles: 'Mijl',
  unit_kilometers: 'Kilometer',
  recent_stations: 'Recente stations',
  clear_recents: 'Recente wissen',
  currents: 'Stromingen',
  nautical_charts: 'Zeekaarten',
  browse_by_country: 'Bladeren op land',
  countries_auto: 'Automatisch',
  countries_always: 'Altijd',
  countries_never: 'Nooit',
  show: 'Tonen',
  hide: 'Verbergen',

  // --- Station pages (tide + current) ---
  tide_title: 'Getijden bij {{name}}',
  current_title: 'Stromingen bij {{name}}',
  last_tide: 'Vorige',
  next_tide: 'Volgende',
  coefficient: 'Coef',
  last_current: 'Vorige stroming',
  next_current: 'Volgende stroming',
  following_current: 'Komende stroming',
  high: 'Hoog',
  low: 'Laag',
  tides: 'Getijden',
  sun: 'Zon',
  moon: 'Maan',
  sunrise_now: 'Zonsopgang',
  sunset_now: 'Zonsondergang',
  moonrise_now: 'Maansopgang',
  moonset_now: 'Maansondergang',
  sunrise_week: 'Opgang',
  sunset_week: 'Ondergang',
  moonrise_week: 'Opgang',
  moonset_week: 'Ondergang',
  add_to_favorites: 'Toevoegen aan favorieten',
  remove_from_favorites: 'Verwijderen uit favorieten',

  // --- Week table dates ---
  today: 'Vandaag',
  tomorrow: 'Morgen',

  // --- Moon phases ---
  phase_new_moon: 'Nieuwe maan',
  phase_waxing_crescent: 'Wassende maansikkel',
  phase_first_quarter: 'Eerste kwartier',
  phase_waxing_gibbous: 'Wassende maan',
  phase_full_moon: 'Volle maan',
  phase_waning_gibbous: 'Afnemende maan',
  phase_last_quarter: 'Laatste kwartier',
  phase_waning_crescent: 'Afnemende maansikkel',

  // --- Tide / current status vocabulary ---
  rising: 'Stijgend',
  falling: 'Dalend',
  high_tide: 'Hoog water',
  low_tide: 'Laag water',
  ebb: 'Eb',
  flood: 'Vloed',
  slack: 'Stil water',

  // --- Relative time ---
  just_now: 'Zojuist',
  somethings_wrong: 'Er is een fout opgetreden',
  hour_ago: '{{hour}} uur geleden',
  hours_ago: '{{hour}} uur geleden',
  minute_ago: '{{minute}} minuut geleden',
  minutes_ago: '{{minute}} minuten geleden',
  hour_minute_ago: '{{hour}} uur en {{minute}} minuut geleden',
  hour_minutes_ago: '{{hour}} uur en {{minute}} minuten geleden',
  hours_minute_ago: '{{hour}} uur en {{minute}} minuut geleden',
  hours_minutes_ago: '{{hour}} uur en {{minute}} minuten geleden',
  hour_from_now: 'Over {{hour}} uur',
  hours_from_now: 'Over {{hour}} uur',
  minute_from_now: 'Over {{minute}} minuut',
  minutes_from_now: 'Over {{minute}} minuten',
  hour_minute_from_now: 'Over {{hour}} uur en {{minute}} minuut',
  hour_minutes_from_now: 'Over {{hour}} uur en {{minute}} minuten',
  hours_minute_from_now: 'Over {{hour}} uur en {{minute}} minuut',
  hours_minutes_from_now: 'Over {{hour}} uur en {{minute}} minuten',

  // --- Insights ---
  insights_7_day_overview: '7-dagen inzichten',
  no_insights_available: 'Geen inzichten beschikbaar voor dit station.',
  insights_current_extremes: 'Stroomextremen',
  insights_fastest_flood: 'Snelste vloed',
  insights_fastest_ebb: 'Snelste eb',
  insights_strongest_daily_currents: 'Dagelijkse piekstromen',
  insights_fastest_current: 'Snelste',
  insights_slowest_current: 'Langzaamste',
  insights_tidal_extremes: 'Getijdenextremen',
  insights_highest_tide: 'Hoogste tij',
  insights_lowest_tide: 'Laagste tij',
  insights_strongest_daily_movements: 'Grootste getijbereiken',
  insights_largest_tide: 'Grootste',
  insights_smallest_tide: 'Kleinste',
  insights_value_at_time: '{{value}} om {{time}}',
  insights_tidal_range_label: 'getijbereik',
  insights_max_current_label: 'max stroom',

  // --- Insight bands ---
  band_smaller_than_usual: 'Kleiner dan gebruikelijk',
  band_typical: 'Typisch',
  band_larger_than_usual: 'Groter dan gebruikelijk',
  band_unusually_large: 'Ongewoon groot',
  band_lower_than_usual: 'Lager dan gebruikelijk',
  band_unusually_low: 'Ongewoon laag',
  band_slower_than_usual: 'Langzamer dan gebruikelijk',
  band_faster_than_usual: 'Sneller dan gebruikelijk',
  band_unusually_fast: 'Ongewoon snel',
  band_smaller_than_usual_height: 'Lager dan gebruikelijk',
  band_larger_than_usual_height: 'Hoger dan gebruikelijk',
  band_unusually_large_height: 'Ongewoon hoog',

  // --- Map attribution ---
  attribution: 'Bronvermelding',
  attribution_osm: 'Kaartgegevens © OpenStreetMap-bijdragers',
  attribution_tiles: 'Kaarttegels door OpenFreeMap',
  attribution_style: 'Kaartstijl © OpenMapTiles',
  ok: 'OK',

  // --- Explore map ---
  current_speed: 'Stroomsnelheid',
  depth: 'Diepte',
  speed: 'Snelheid',
  depth_datum: 'Dieptes vanaf',
  depth_drying: 'Valt droog',
  depth_loading: 'Dieptegegevens laden…',
  depth_datum_tag: 'Dieptes in {{unit}} onder {{datum}}',
  depth_not_for_navigation: 'Niet voor navigatie.',
  depth_unavailable: 'Dieptegegevens zijn nu niet beschikbaar.',
  depth_unit_m: 'm',
  depth_unit_ft: 'ft',
  go_mode_start: 'GO',
  go_mode_start_label: 'Go-modus starten',
  go_mode_exit: 'Go-modus afsluiten',
  go_mode_location_denied:
    'De Go-modus heeft je locatie nodig. Schakel deze in via het slotpictogram.',
  go_mode_location_denied_ok: 'OK',
  radar: 'Radar',
  radar_precipitation: 'Neerslag',
  radar_light: 'licht',
  radar_moderate: 'matig',
  radar_heavy: 'zwaar',
  radar_storm: 'zeer zwaar',
  radar_forecast: 'verwachting',
  radar_none_for_time: 'geen radar voor dit tijdstip',
  now: 'Nu',
  explore_prompt_denied:
    'Locatie staat uit voor deze site - schakel het in via het slotpictogram in de adresbalk.',
  open_full_map: 'Open de volledige kaart',
  close_full_map: 'Sluit de volledige kaart',
  explore_full_map: 'Verken de volledige kaart',
  center_on_location: 'Centreren op mijn locatie',
  show_my_location: 'Mijn locatie tonen',
  map_knots_label: '{{speed}} kt',

  // --- Location pages ---
  states: 'provincies',
  no_stations_found_location: 'Geen stations gevonden.',
  tides_and_currents_by_country: 'Getijden en stromingen per land',

  // --- SEO titles / descriptions ---
  settings_seo_description: 'Kies je eenheden voor getijhoogten en afstanden.',
  tide_seo_description:
    'Getijdenvoorspellingen, tijden van hoog- en laagwater voor {{name}}{{location}}.',
  current_seo_description:
    'Voorspellingen van getijstromingen, tijden van vloed en eb voor {{name}}{{location}}.',
  location_title: 'Getijden en stromingen bij {{name}}',
  country_seo_description:
    'Getijdentijden en voorspellingen van getijstromingen voor {{name}}. Bekijk {{stateTerm}} en kustgetijdenstations in {{name}}.',
  state_seo_description:
    'Getijden- en stromingsvoorspellingen voor {{name}}, {{country}}. Tijden van hoog- en laagwater voor kuststations in {{name}}.',
  city_seo_description:
    'Getijdentijden en voorspellingen van getijstromingen voor {{place}}. Hoog- en laagwater en stromingen bij {{name}}.',
  // --- Chart pages (chart titles, numbers and purposes stay in the
  // issuing authority's language: they name a specific printed sheet) ---
  charts_for_station: 'Zeekaarten voor {{name}}',
  chart_intro:
    'Gratis zeekaart van {{title}}: ingemeten dieptes, boeien, bakens, rotsen, wrakken, jachthavens, ankerplaatsen en getijdenstations.',
  chart_page_name: 'Zeekaart van {{title}}',
  chart_seo_description:
    'Gratis zeekaart van {{title}}: ingemeten dieptes, boeien, bakens, rotsen, wrakken, jachthavens, ankerplaatsen en getijdenstations.',

  countries_seo_title: 'Getijden- en stromingstations per land',
  countries_seo_description:
    'Bekijk getijden- en stromingstations per land. Tijden van hoog- en laagwater en voorspellingen van getijstromingen voor kustlocaties wereldwijd.',
  home_seo_description:
    'Vind getijdentijden en voorspellingen van getijstromingen voor kuststations bij jou in de buurt. Bekijk hoog- en laagwater voor je locatie of blader door stations per land.',
  explore_play: 'Afspelen',
  explore_pause: 'Pauzeren',
  explore_playback_speed: 'Afspeelsnelheid',
  explore_time: 'Tijd',
  skip_to_content: 'Ga naar hoofdinhoud',
  // --- Weather (station pages) ---
  weather: 'Maritiem weer',
  wind: 'Wind',
  gusts: 'Windstoten',
  seas: 'Golven',
  time: 'Tijd',
  air_temp: 'Lucht',
  water_temp: 'Water',
  water_temperature: 'Watertemperatuur',
  humidity: 'Luchtvochtigheid',
  pressure: 'Luchtdruk',
  precip_chance: 'Neerslag',
  chances: 'Kans',
  precip_rate: 'Neerslagintensiteit',
  visibility: 'Zicht',
  condition_thunderstorms: 'Onweer',
  condition_freezing_rain: 'IJzel',
  condition_sleet: 'Natte sneeuw',
  condition_snow: 'Sneeuw',
  condition_fog: 'Mist',
  condition_rain: 'Regen',
  condition_cloudy: 'Bewolkt',
  condition_partly_cloudy: 'Gedeeltelijk bewolkt',
  condition_clear: 'Helder',
  weather_thunder: 'Onweer',
  note_seas_computed_from_wind: 'Golfhoogten zijn geschat op basis van wind en kustlijn.',
  note_seas_from_nearby_open_water: 'De golfslag komt van nabijgelegen open water.',
  note_seas_open_water_nearby:
    'De golven op het open water dichtbij zijn ongeveer {{height}}. Hier kan het rustiger zijn.',
  note_seas_open_water_distant:
    'De golven op open water op {{distance}} afstand zijn ongeveer {{height}}. Hier kan het rustiger zijn.',
  note_seas_open_water_distant_dir:
    'De golven op open water op {{distance}} {{direction}} van hier zijn ongeveer {{height}}. Hier kan het rustiger zijn.',
  note_seas_unavailable: 'Voor dit punt is geen betrouwbare golfslag beschikbaar.',
  note_sheltered_water_sees_less:
    'Op beschut water zijn de golven meestal lager dan deze waarden voor open water.',
  note_no_warning_feed_coverage: 'Geen officiële maritieme waarschuwingsdienst dekt dit punt.',
  note_nearest_point_across_land:
    'Het dichtstbijzijnde voorspellingspunt ligt aan de overkant van land.',
  warnings_none_active: 'Geen maritieme waarschuwingen van kracht',
  warnings_unavailable: 'Maritieme waarschuwingen zijn niet beschikbaar voor deze locatie',
  warning_show_text: 'Officiële tekst tonen',
  warning_hide_text: 'Officiële tekst verbergen',
  weather_updated: 'Bijgewerkt {{time}}',
  current_conditions: 'Actuele omstandigheden',
  daily_forecast: 'Dagelijkse verwachting',
  expand_for_hourly: 'Uitklappen voor uurcijfers',
  hourly: 'Per uur',
  hourly_forecast: 'Uurverwachting',
  wind_speed: 'Windsnelheid',
  wind_gusts: 'Wind en windstoten',
  pressure_humidity: 'Luchtdruk en luchtvochtigheid',
  max_seas: 'Max. golfhoogte',
  visibility_excellent: 'Uitstekend',
  visibility_good: 'Goed',
  visibility_moderate: 'Matig',
  visibility_poor: 'Slecht',
  forecaster_text_link: 'Verwachtingstekst van {{issuer}}',
  temperature: 'Temperatuur',
  unit_fahrenheit: 'Fahrenheit',
  unit_celsius: 'Celsius',
  // --- Conditions summary (station pages) ---
  // Sea state: WMO Sea State Code. Wind: Beaufort. Both are published
  // scales with standard terminology in each language, not our own wording.
  // Warning-window and low–high range punctuation. CJK marks a range (and
  // an open end) with ～, not an en dash or a trailing plus.
  warning_window_range: '{{start}} – {{end}}',
  warning_window_open: '{{start}}+',
  range_separator_short: '-',
  // Wave-period fragments. The connector is the locale's own word for the
  // "at" in "0.5 m S @ 3s" (CJK says "period" instead); the value carries
  // the locale's seconds notation (秒/초 — bare Latin "s" reads as an
  // untranslated fragment in CJK weather products).
  seas_period_at: 'bij',
  wave_period_short: '{{period}}s',
  // 16-point compass, per this locale’s meteorological convention — the
  // letters differ across languages (Z/O/Ø/V…) and CJK writes the words out.
  compass_N: 'N',
  compass_NNE: 'NNO',
  compass_NE: 'NO',
  compass_ENE: 'ONO',
  compass_E: 'O',
  compass_ESE: 'OZO',
  compass_SE: 'ZO',
  compass_SSE: 'ZZO',
  compass_S: 'Z',
  compass_SSW: 'ZZW',
  compass_SW: 'ZW',
  compass_WSW: 'WZW',
  compass_W: 'W',
  compass_WNW: 'WNW',
  compass_NW: 'NW',
  compass_NNW: 'NNW',
  // Known warning types, one badge label each. Bureau-home locales use the
  // bureau’s official terminology. Unknown types fall back to the humanized
  // English code in every locale (see warningTypeLabel).
  warning_type_small_craft_advisory: 'Waarschuwing kleine vaartuigen',
  warning_type_gale_warning: 'Stormwaarschuwing',
  warning_type_gale_watch: 'Kans op storm',
  warning_type_storm_warning: 'Waarschuwing zware storm',
  warning_type_storm_watch: 'Kans op zware storm',
  warning_type_hurricane_force_wind_warning: 'Orkaanwaarschuwing',
  warning_type_hurricane_force_wind_watch: 'Kans op orkaan',
  warning_type_special_marine_warning: 'Speciale maritieme waarschuwing',
  warning_type_marine_weather_statement: 'Maritiem weerbericht',
  warning_type_hazardous_seas_warning: 'Waarschuwing gevaarlijke zeegang',
  warning_type_brisk_wind_advisory: 'Waarschuwing vrij krachtige wind',
  warning_type_low_water_advisory: 'Waarschuwing laag water',
  warning_type_dense_fog_advisory: 'Waarschuwing dichte mist',
  warning_type_heavy_freezing_spray_warning: 'Waarschuwing zware ijsafzetting',
  warning_type_strong_wind_warning: 'Waarschuwing harde wind',
  warning_type_gale_force_wind_warning: 'Stormwaarschuwing',
  warning_type_storm_force_wind_warning: 'Waarschuwing zware storm',
  warning_type_wind_warning: 'Windwaarschuwing',
  warning_type_dense_fog_warning: 'Waarschuwing dichte mist',
  warning_type_icing_warning: 'IJsafzettingswaarschuwing',
  warning_type_typhoon_warning: 'Tyfoonwaarschuwing',
  warning_type_wind_wave_warning: 'Waarschuwing hoge golven',
  warning_type_wind_wave_advisory: 'Golfwaarschuwing',
  warning_type_strong_wind_advisory: 'Waarschuwing krachtige wind',
  warning_type_storm_surge_warning: 'Stormvloedwaarschuwing',
  warning_type_storm_surge_advisory: 'Waarschuwing stormvloed',
  warning_type_thunderstorm_warning: 'Onweerswaarschuwing',
  warning_type_rough_sea_warning: 'Waarschuwing ruwe zee',
  warning_type_fog_warning: 'Mistwaarschuwing',
  sea_state_calm_rippled: 'Gerimpelde zee',
  sea_state_smooth: 'Kalme zee',
  sea_state_slight: 'Licht bewogen zee',
  sea_state_moderate: 'Matig bewogen zee',
  sea_state_rough: 'Ruwe zee',
  sea_state_very_rough: 'Zeer ruwe zee',
  sea_state_high: 'Hoge zee',
  sea_state_very_high: 'Zeer hoge zee',
  sea_state_phenomenal: 'Uitzonderlijke zee',
  hazard_showers: 'Buien',
  hazard_reduced_visibility: 'Beperkt zicht',
  hazard_haze: 'Nevel',
  hazard_waterspout: 'Waterhozen',
  hazard_freezing_spray: 'IJsafzetting door opspattend water',
  hazard_ice: 'IJs',
  marine_summary_sea_wind: '{{sea}}, {{direction}}-wind met {{speed}}.',
  marine_summary_wind_only_gusting: '{{direction}}-wind met {{speed}}, uitschieters {{gust}}.',
  marine_summary_sea_wind_gusting:
    '{{sea}}, {{direction}}-wind met {{speed}}, uitschieters {{gust}}.',
  marine_summary_wind_only: '{{direction}}-wind met {{speed}}.',
  marine_summary_sea_only: '{{sea}}.',
  marine_prediction_caveat_tide_one:
    'Getijvoorspellingen zijn astronomisch, dus het weer in die waarschuwing kan het werkelijke peil verhogen of verlagen.',
  marine_prediction_caveat_tide_many:
    'Getijvoorspellingen zijn astronomisch, dus het weer in die waarschuwingen kan het werkelijke peil verhogen of verlagen.',
  marine_prediction_caveat_current_one:
    'Stroomvoorspellingen zijn astronomisch, dus het weer in die waarschuwing kan de werkelijke stroom versterken of verzwakken.',
  marine_prediction_caveat_current_many:
    'Stroomvoorspellingen zijn astronomisch, dus het weer in die waarschuwingen kan de werkelijke stroom versterken of verzwakken.',
  marine_warning_active: 'Voor dit gebied geldt een maritieme waarschuwing.',
  marine_warnings_active: 'Voor dit gebied gelden maritieme waarschuwingen.',
  marine_warning_upcoming: 'Voor dit gebied geldt een maritieme waarschuwing vanaf {{time}}.',
  marine_warnings_upcoming: 'Voor dit gebied gelden maritieme waarschuwingen vanaf {{time}}.',
  marine_summary_hazard_now: 'Op dit moment: {{hazard}}.',
  marine_summary_hazard_later: 'In de verwachting: {{hazard}}.',
  marine_tide_rising:
    'Het water staat op {{height}} en komt op: volgend hoogwater {{next}} om {{time}}.',
  marine_tide_falling:
    'Het water staat op {{height}} en zakt: volgend laagwater {{next}} om {{time}}.',
  marine_current_flood: 'Volgende vloedstroom {{speed}} om {{time}}.',
  marine_current_ebb: 'Volgende ebstroom {{speed}} om {{time}}.',
  marine_current_slack: 'Volgende stroomkentering om {{time}}.',
  marine_current_now_flood: 'De stroom loopt binnen met {{speed}}.',
  marine_current_now_ebb: 'De stroom loopt uit met {{speed}}.',
  marine_current_now_slack: 'Stroomkentering.',
  marine_current_peak: 'Maximum {{speed}} om {{time}}.',

  // --- Chart furniture (navaid / hazard / POI click popups) ---
  // See en.js for the rules these follow. "IALA A" / "IALA B" stay untranslated
  // in every language: it is the standard's name.
  furn_light: 'Licht',
  furn_buoy: 'Boei',
  furn_beacon: 'Baken',
  furn_wreck: 'Wrak',
  furn_rock: 'Rots',
  furn_obstruction: 'Obstructie',
  furn_anchorage: 'Ankerplaats',
  furn_tss: 'Verkeersscheidingsstelsel',
  furn_routing: 'Routering',
  furn_title_buoy: '{{category}} boei',
  furn_title_beacon: '{{category}} baken',
  furn_cat_port: 'Bakboord',
  furn_cat_starboard: 'Stuurboord',
  furn_cat_preferred_channel_port: 'Voorkeursvaarwater bakboord',
  furn_cat_preferred_channel_starboard: 'Voorkeursvaarwater stuurboord',
  furn_cat_safe_water: 'Veilig vaarwater',
  furn_cat_isolated_danger: 'Geïsoleerd gevaar',
  furn_cat_north: 'Noord',
  furn_cat_east: 'Oost',
  furn_cat_south: 'Zuid',
  furn_cat_west: 'West',
  furn_cat_special: 'Bijzondere',
  furn_cat_mooring: 'Meer',
  furn_cat_lateral: 'Laterale',
  furn_characteristic: 'Karakter',
  furn_range: 'Lichtbereik',
  furn_height: 'Hoogte',
  furn_colour: 'Kleur',
  furn_shape: 'Vorm',
  furn_lights_on_mark: 'Lichten op dit teken',
  furn_topmark: 'Topteken',
  furn_class: 'Klasse',
  furn_least_depth_over: 'Minste diepte boven',
  furn_depth_over: 'Diepte boven',
  furn_state: 'Toestand',
  furn_type: 'Type',
  furn_range_value: '{{value}} M',
  furn_metres_value: '{{value}} m',
  furn_cable: 'Onderzeese kabel',
  furn_pipeline: 'Pijpleiding',
  furn_restricted_area: 'Beperkt gebied',
  furn_restriction: 'Beperking',
  furn_mpa: 'Beschermd zeegebied',
  furn_protection: 'Bescherming',
  furn_agency: 'Beheerd door',
  furn_mpa_note: 'Een natuurbeschermingsaanduiding, geen navigatiebeperking.',
  furn_sector: 'Sector',
  furn_sector_value: '{{from}}° → {{to}}°',
  lightw_f: 'Vast {{colour}} licht.',
  lightw_fl: 'Schittert {{colour}} elke {{period}} seconden.',
  lightw_fl_group: 'Schittert {{colour}} in groepen van {{count}}, elke {{period}} seconden.',
  lightw_lfl: 'Een lange {{colour}} schittering elke {{period}} seconden.',
  lightw_q: 'Snel {{colour}} flikkerlicht.',
  lightw_iso: 'Gelijk {{colour}} licht en donker, elke {{period}} seconden.',
  lightw_oc: 'Vast {{colour}} licht met korte verduistering elke {{period}} seconden.',
  lightcolour_white: 'wit',
  lightcolour_red: 'rood',
  lightcolour_green: 'groen',
  lightcolour_yellow: 'geel',
  furn_feet_charted_value: '{{feet}} ft ({{metres}} m volgens kaart)',
  furn_light_yes: 'ja',
  furn_shown_neutral: '{{colours}} (neutraal weergegeven)',
  furn_note_light: "Zo toont het licht zich 's nachts; de zeevarende herkent het eraan.",
  furn_note_lateral_b_port:
    'Markeert de LINKERzijde van het vaarwater vanaf zee (IALA B: groene stompe ton).',
  furn_note_lateral_b_starboard:
    'Markeert de RECHTERzijde van het vaarwater vanaf zee (IALA B: “rood rechts bij binnenkomst”).',
  furn_note_lateral_a_port:
    'Markeert de BAKBOORDzijde van het vaarwater vanaf zee (IALA A: rood aan bakboord).',
  furn_note_lateral_a_starboard:
    'Markeert de STUURBOORDzijde van het vaarwater vanaf zee (IALA A: groen aan stuurboord).',
  furn_note_safe_water: 'Rondom veilig vaarwater, meestal de aanloop- of midvaarwaterton.',
  furn_note_isolated_danger: 'Ligt boven een geïsoleerd gevaar met bevaarbaar water eromheen.',
  furn_note_cardinal_north: 'Kardinale ton: passeer aan de NOORDzijde.',
  furn_note_cardinal_east: 'Kardinale ton: passeer aan de OOSTzijde.',
  furn_note_cardinal_south: 'Kardinale ton: passeer aan de ZUIDzijde.',
  furn_note_cardinal_west: 'Kardinale ton: passeer aan de WESTzijde.',
  furn_note_special: 'Bijzondere ton (geel): grenzen, kabels, ligplaatsen, wedstrijden.',
  furn_note_preferred_starboard: 'Splitsingsmarkering: de voorkeursvaargeul ligt aan stuurboord.',
  furn_note_preferred_port: 'Splitsingsmarkering: de voorkeursvaargeul ligt aan bakboord.',
  furn_note_mooring: 'Meerboei.',
  furn_vessel: 'Schip',
  furn_depth_quality: 'Dieptekwaliteit',
  furn_length: 'Lengte',
  furn_position_accuracy: 'Positienauwkeurigheid',
  furn_remarks: 'Opmerkingen',
  furn_circumstances: 'Omstandigheden',
  furn_status: 'Status',
  furn_note_shom: 'In kaart gebracht door Shom (Frankrijk). ©Shom, CC BY-SA 4.0.',
  furn_lock: 'Sluis',
  furn_bridge: 'Brug',
  furn_overhead_cable: 'Bovenleiding',
  furn_notice_mark: 'Waarschuwingsbord',
  furn_distance_mark: 'Afstandsmarkering',
  furn_daymark: 'Dagmerk',
  furn_channel: 'Vaargeul',
  furn_vertical_clearance_closed: 'Doorvaarthoogte (gesloten)',
  furn_vertical_clearance_open: 'Doorvaarthoogte (geopend)',
  furn_datum: 'Referentievlak',
  furn_datum_value: '{plane} (VERDAT {code})',
  furn_datum_unknown: 'unknown code (VERDAT {code})',
  furn_note_ienc:
    'Binnen-ENC (US Army Corps of Engineers). Doorvaarthoogten gelden boven het hierboven genoemde referentievlak; bij hoog water is de werkelijke hoogte minder.',
  furn_note_wreck: 'Gekarteerd wrak. Dieptes zijn kaartwaarden, niet geverifieerd.',
  furn_note_anchorage: 'Gekarteerde ankerplaats.',
  furn_note_tss: 'Eenrichtingsvaarbanen. Kleine vaartuigen kruisen haaks en houden vrij.',
  furn_route: 'Route',
  furn_fairway: 'Vaarwater',
  furn_recommended_track: 'Aanbevolen koers',
  furn_navigation_line: 'Navigatielijn',
  furn_leading_line: 'Geleidelijn',
  furn_clearing_line: 'Vrijvaarlijn',
  furn_transit_line: 'Transitlijn',
  furn_traffic: 'Verkeer',
  furn_orientation: 'Oriëntatie',
  furn_degrees_value: '{{value}}°',
  furn_note_fairway: 'Op de kaart aangegeven vaarwater: de onderhouden of aanbevolen geul.',
  furn_note_track: 'Op de kaart aangegeven koerslijn.',
  furn_note_track_fixed_marks:
    'Op de kaart aangegeven koerslijn, gebaseerd op vaste merktekens (geleidelijnen).',
  furn_note_leading_line: 'Houd de geleidemerken in lijn om op de aangegeven lijn te blijven.',
  furn_note_navigation_line: 'Op de kaart aangegeven navigatielijn.',
  furn_poi_marina: 'Jachthaven',
  furn_poi_fuel: 'Brandstof',
  furn_poi_slipway: 'Trailerhelling',
  furn_poi_ferry_terminal: 'Veerterminal',
  furn_poi_boatyard: 'Scheepswerf',
  furn_poi_lighthouse: 'Vuurtoren',
  furn_note_slipway: 'Trailerhelling.',
  // Layers sheet — UNTRANSLATED, English placeholders (2026-09-11). Catalog
  // parity is enforced by scripts/check-locale-keys.mjs, so a key cannot be
  // added to en.js alone; these are placeholders awaiting translation, not
  // a claim that the strings are localized.
  layers: 'Layers',
  layers_close: 'Close layers',
  layers_map_type: 'Map type',
  layers_visualizations: 'Visualizations',
  layers_standard_map: 'Standard Map',
  layers_depth_chart: 'Depth Chart',
  layers_moving_tides: 'Moving Tides',
  layers_moving_currents: 'Moving Currents',
  layers_wind_waves: 'Wind & Waves',
  layers_weather_radar: 'Weather Radar',
  layers_coming_soon: 'Coming soon',
  layers_no_currents_here: 'No current stations in view',
  layers_no_radar_here: 'No radar coverage in view',
  // The compass button's accessible name. {{point}} is a 16-point direction
  // (SSW) and {{deg}} the exact bearing — the face rounds to 8 points, this
  // does not. English placeholder in the non-English catalogs, awaiting
  // translation; catalog parity is enforced by scripts/check-locale-keys.mjs.
  follow_my_direction: 'Mijn richting volgen',
  compass_faces: 'Map faces {{point}} · {{deg}}°, tap for north-up',
  ww_row_no_data: '{{row}}: hier geen gegevens',
  ww_row_no_forecast_after: '{{row}}: geen verwachting na {{when}}',
  ww_row_no_forecast: '{{row}}: geen verwachting zo ver vooruit',
  ww_unavailable: 'Weergegevens niet beschikbaar',
  explore_show_player: 'Tijdlijn weergeven',
  explore_hide_player: 'Tijdlijn verbergen',

  // --- Routeplanning op /explore ---
  // Beschrijven, nooit adviseren; nooit "veilig". De disclaimer van de dienst
  // komt letterlijk uit het antwoord; route_disclaimer is alleen de terugval.
  route_plan: 'Route plannen',
  route_leave: 'Routeplanning verlaten',
  route_title: 'Route',
  route_prompt_start: 'Tik op het water waar je vertrekt.',
  route_prompt_start_desktop: 'Klik op het water waar je vertrekt en klik daarna op je bestemming.',
  route_prompt_end: 'Start ingesteld. Tik nu op je bestemming.',
  route_prompt_end_desktop: 'Start ingesteld. Klik nu op je bestemming.',
  route_drag_hint: 'Spelden kun je verslepen.',
  route_clear: 'Wissen',
  route_swap: 'Start en bestemming omwisselen',
  route_share: 'Link kopiëren',
  route_copied: 'Link gekopieerd',
  route_start: 'Start',
  route_destination: 'Bestemming',
  route_near: 'bij {{name}}',
  route_loading: 'Route wordt uitgezet…',
  route_loading_sub: 'Meestal een paar seconden. Sommige gebieden duren tot 30 seconden.',
  route_loading_slow: 'Nog bezig…',
  route_loading_slow_sub: 'Dit gebied duurt langer dan normaal.',
  route_summary_time: '{{duration}} bij {{speed}}',
  route_planning_speed: 'Planningssnelheid',
  route_shoalest: 'Ondiepste punt op de route',
  route_planning_draft: 'planningsdiepgang',
  route_change: 'wijzigen',
  route_draft_title: 'Planningsdiepgang',
  route_draft_help:
    'De diepte waarvoor de route wordt gepland, niet de diepgang van je boot. Dieper vindt minder wegen, ondieper meer.',
  route_datum: 'Dieptes op kaartnul (MLLW), zonder getij.',
  route_unassured_note:
    'Oranje stukken lopen door water dat kaart en opmeting onder {{draft}} niet oplossen.',
  route_row_start: 'Start {{label}}',
  route_row_heading: 'koers {{course}}° ({{point}})',
  route_row_end: 'Aankomst {{label}}',
  route_row_end_sub: 'einde van de route',
  route_turn_left: 'Ga links naar {{course}}°',
  route_turn_right: 'Ga rechts naar {{course}}°',
  route_bear_left: 'Houd links aan naar {{course}}°',
  route_bear_right: 'Houd rechts aan naar {{course}}°',
  route_then: '{{first}}, daarna {{second}}',
  route_keep_mark: 'Houd {{mark}} aan je {{hand}}',
  route_leave_channel: 'Verlaat de vaargeul bij {{mark}}',
  route_on_your: 'aan je {{hand}} ({{side}})',
  route_hand_left: 'linkerhand',
  route_hand_right: 'rechterhand',
  route_side_port: 'bakboord',
  route_side_starboard: 'stuurboord',
  route_mark_buoy: '{{color}} ton {{num}}',
  route_mark_light: '{{color}} licht {{num}}',
  route_mark_daybeacon: '{{color}} baken {{num}}',
  route_mark_lighted: '{{mark}} (verlicht)',
  route_red: 'rode',
  route_green: 'groene',
  route_follow: 'Volg {{name}}',
  route_follow_two: 'Volg {{first}}, daarna {{second}}',
  route_follow_channel: 'de vaargeul {{name}}',
  route_follow_named: '{{name}}',
  route_follow_unnamed: 'de betonde vaargeul',
  route_follow_marks: '{{count}} markeringen',
  route_greens_on: 'groen aan je {{hand}}',
  route_reds_on: 'rood aan je {{hand}}',
  route_show_marks: 'Markeringen tonen',
  route_hide_marks: 'Markeringen verbergen',
  route_why: 'Waarom draait de route hier?',
  route_turn_reason: 'Draait hier omdat {{reason}}',
  route_lights: 'Lichten binnen bereik: {{lights}}',
  route_stretch_unassured: 'diepte onder {{draft}} niet opgelost',
  route_stretch_rocky: 'tussen gekaarte rotsen',
  route_stretch_canal:
    'kanaal: schutten, sluisdeuren en doorvaarthoogte van bruggen niet gemodelleerd',
  route_step_of: 'Stap {{n}} van {{total}}',
  route_all_steps: 'Alle stappen',
  route_prev_step: 'Vorige stap',
  route_next_step: 'Volgende stap',
  route_minutes: '{{n}} min',
  route_hours: '{{h}} u',
  route_hours_minutes: '{{h}} u {{m}} min',
  route_err_on_land_origin: 'Je start ligt op gekaart land',
  route_err_on_land_destination: 'Je bestemming ligt op gekaart land',
  route_err_on_land_origin_sub:
    'Sleep de startspeld het water in. Een kwelder, een strand of een steiger telt op de kaart als land.',
  route_err_on_land_destination_sub:
    'Sleep de bestemmingsspeld het water in. Een kwelder, een strand of een steiger telt op de kaart als land.',
  route_err_no_route: 'Geen route bij een planningsdiepgang van {{draft}}',
  route_err_no_route_sub:
    'Ergens tussen de twee punten is de kaart ondieper dan {{draft}}. Een kleinere planningsdiepgang vindt misschien een weg.',
  route_err_no_snap: 'Geen gekaart water bij een van de punten',
  route_err_no_snap_sub: 'Zet de spelden dichter bij open water.',
  route_err_outside: 'Routeplanning dekt voorlopig Amerikaanse wateren',
  route_err_outside_sub:
    'Routes worden gemaakt met NOAA-kaarten, dus beide punten moeten in Amerikaanse wateren liggen. Meer kusten volgen.',
  route_err_timeout: 'De routedienst deed er te lang over',
  route_err_timeout_sub: 'Sommige gebieden duren tot 30 seconden en bij dit gebied was de tijd op.',
  route_err_unavailable: 'Routeplanning is nu niet beschikbaar',
  route_err_unavailable_sub: 'Probeer het zo opnieuw.',
  route_err_busy: 'Te veel routeaanvragen',
  route_err_busy_sub: 'Wacht een minuut en probeer het opnieuw.',
  route_try_again: 'Opnieuw proberen',
  route_disclaimer:
    'Niet voor navigatie. Deze route volgt de betonde vaargeul zoals op de kaart aangegeven; het is geen bewering dat het water veilig is.',
  route_promo_title: 'Volg deze route in de app met de Go-modus',
  route_promo_body:
    'De Go-modus houdt je boot op de kaart met de afstand tot de volgende markering of draai, de diepte onder je en het getij en de stroming van het dichtstbijzijnde station. In Tides Near Me voor iPhone en Android, met een abonnement.',
}
